import * as React from 'react';

interface ErrorBoundaryState {
  isErrorThrown: boolean;
}

export class ErrorBoundary extends React.Component<{}, ErrorBoundaryState> {
  state = {
    isErrorThrown: false,
  };

  static getDerivedStateFromError(error: any) {
    return { isErrorThrown: true };
  }

  componentDidCatch(_error: Error, _info: React.ErrorInfo) {
    // do nothing. error already tracked by datadog RUM
  }

  render() {
    if (this.state.isErrorThrown) {
      return <h1>Something went wrong</h1>;
    }
    return this.props.children;
  }
}
